import { Action } from 'redux';

/**
 * Actions for feature flags
 */

export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';

/**
 * Initialise the feature flags for the app
 * @param flags an object where each property is a feature flag (e.g. boolean)
 */
export const setFeatureFlags = (flags: {
    [key: string]: string | boolean | object;
}): Action<typeof SET_FEATURE_FLAGS> & {
    flags: { [key: string]: string | boolean | object };
} => ({
    type: SET_FEATURE_FLAGS,
    flags,
});
